import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../theme/ThemeProvider';
import './ThemeToggle.css';

export const ThemeToggle: React.FC<{ className?: string }> = ({ className }) => {
  const { resolved, toggle } = useTheme();

  return (
    <button
      type="button"
      className={['gx-theme-toggle', className].filter(Boolean).join(' ')}
      onClick={toggle}
      aria-label={resolved === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      title={resolved === 'dark' ? 'Light mode' : 'Dark mode'}
    >
      <span className="gx-theme-toggle__icon" aria-hidden="true">
        {resolved === 'dark' ? <Sun size={16} /> : <Moon size={16} />}
      </span>
      <span className="gx-theme-toggle__label">{resolved === 'dark' ? 'Light' : 'Dark'}</span>
    </button>
  );
};

